import type { RouteConfig } from "@/types/routestypes";
import { lazy } from "react";

const Team = lazy(() => import("@/pages/MyTeam/Team"));
const MyTeam = lazy(() => import("@/pages/MyTeam/MyTeamModule"));
const LatePunchIn = lazy(() => import("@/pages/MyTeam/components/LatePunchIn/LatePunchIn"));
const Hierarchy = lazy (()=> import("@/pages/MyTeam/components/Hierarchy/OrganizationHierarchy"));

const MyTeamRoute: RouteConfig = {
    path: "/myteam",
    element: <Team />,
    pageName: "My Team",
    sidebar: { show: true, icon: "/assets/media/teamLogo.svg" },
    children: {
        MAIN: {
            path: "",
            element: <MyTeam />,
            pageName: "My Team",
            sidebar: { show: false },
        },
        LATE_PUNCHIN: {
            path: "latePunchIn",
            element: <LatePunchIn />,
            pageName: "My Team",
            sidebar: { show: false },
        },
        ORG_HIERARCHY:{
            path:"hierarchy",
            element: <Hierarchy />,
            pageName:"My Team",
            sidebar: { show: false },

        }
    }
}

export default MyTeamRoute;